import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import head from "@tinkoff/utils/array/head";
import { batch, useComputed, useSignal, useSignalEffect } from "@preact/signals";
import asArray from "../../../lib/as-array";
import ListFilter from "../ListFilter";
import FilterPill from "../FilterPill";
import layout from "../../Layout/style.module.scss";
import style from "./style.module.scss";
export default function KeyValueFilter(props) {
    const { name, options, open, removable, disabled, multiple = false, allowCustomValues = false, onChange, onRemove, } = props;
    // KeyValueFilter is only build to handle a single key-value pair at a time. For mutiple values,
    // the filter must be configured with `splitValues: true`.
    const defaultValue = head(asArray(props.defaultValue));
    const selectedVariable = useSignal(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value.key);
    const selectedValues = useSignal((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.value.values) || []);
    useSignalEffect(() => {
        var _a;
        // Trigger the onChange callback when the selected variable or value change
        if (onChange && selectedVariable.value && ((_a = selectedValues.value) === null || _a === void 0 ? void 0 : _a.length)) {
            onChange({
                label: "",
                value: {
                    key: selectedVariable.value,
                    values: selectedValues.value,
                },
            });
        }
    });
    const setSelectedVariable = (value) => {
        batch(() => {
            selectedVariable.value = value;
            selectedValues.value = [];
        });
    };
    const selectedVariableOptions = useComputed(() => {
        if (selectedVariable.value) {
            return findOptionByVariableValue(options, selectedVariable.value.value);
        }
        return [];
    });
    const pillName = useComputed(() => {
        if (selectedVariable.value) {
            return selectedVariable.value.label;
        }
        return name;
    });
    // Change the key for the value ListFilter whenever the selected variable changes. This forces
    // a re-render so that the `defaultValue` prop can be updated and we can empty any previously
    // selected values.
    const selectedVariableKey = pillName.value;
    return (_jsx(FilterPill, { attributes: props.attributes, panelTitle: name, name: pillName.value, options: selectedValues.value, open: open, removable: removable, disabled: disabled, onRemove: onRemove, children: _jsxs("div", { className: layout["padding"], children: [_jsx("label", { className: style["key-value-filter__label"], children: "Name" }), _jsx(ListFilter, { allowCustomValues: allowCustomValues, defaultValue: selectedVariable.value, closeOnSelect: true, fullWidth: true, removable: false, options: options, onChange: (option) => setSelectedVariable(asArray(option)[0]) }), selectedVariable.value ? (_jsxs("div", { className: layout["padding-top"], children: [_jsx("label", { className: style["key-value-filter__label"], children: "Value" }), _jsx(ListFilter, { allowCustomValues: allowCustomValues, defaultValue: selectedValues.value, fullWidth: true, multiple: multiple, removable: false, options: selectedVariableOptions.value, onChange: (options) => {
                                selectedValues.value = asArray(options);
                            } }, selectedVariableKey)] })) : null] }) }));
}
function findOptionByVariableValue(options, value) {
    const matchingOption = options.find((option) => option.value === value);
    if (matchingOption) {
        return matchingOption.options;
    }
    return [];
}
